<template>
  <div id="page" :class="derievedClass">
    <slot></slot>
  </div>
</template>

<script>
import { APP_LOAD_THEME } from '@/store/types'

export default {
  computed: {
    derievedClass() {
      let result = this.pageClass
      if (this.fillHeight) {
        result = result + ' page-fill-height'
      }
      return result
    }
  },
  beforeMount() {
    if (this.$store.state.app.loadTheme) {
      this.$store.commit(APP_LOAD_THEME, false)
    }
  },
  props: {
    fillHeight: {
      // Do note: the framework is using flex. When height is fill to 100%
      // flex content will fill up the entire space
      type: Boolean,
      default: false
    },
    pageClass: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
#page {
  width: 100%;
}
.page-fill-height {
  height: 100%;
}
.content {
  // To offset the toolbar margin at the top
  padding: 0px !important;
}

</style>
